import { Plus, type LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';
import { PillButton } from '@/modules/simulator/ui/pill-button';
import { StepPicker } from '../builder/step-picker';
import { LIMITS } from '../custom-tool-draft';

/** An empty builder's one move: pick the first tool. `hint` says how the view links the steps. */
export const FirstTool = ({ icon: Icon, hint, className }: { icon: LucideIcon; hint: string; className?: string }) => (
	<div
		className={cn(
			'flex flex-col items-center gap-3 rounded-2xl border border-gray-300 bg-white px-6 py-7 text-center shadow-[0_1px_2px_rgba(16,24,40,0.06)]',
			className
		)}
	>
		<span className='flex size-10 items-center justify-center rounded-full bg-indigo-50 text-indigo-700'>
			<Icon className='size-5' aria-hidden />
		</span>
		<div className='flex flex-col gap-1'>
			<h2 className='text-sm leading-5 font-medium text-ink'>Start with the first tool</h2>
			<p className='text-xs leading-4.5 text-gray-800'>
				{`Pick at least ${LIMITS.minSteps} tools to combine. They run as steps of one tool the AI calls. ${hint}`}
			</p>
		</div>
		<StepPicker>
			<PillButton variant='primary'>
				<Plus className='size-3.5' />
				Add tool
			</PillButton>
		</StepPicker>
	</div>
);
